import React from 'react';
import { CompassIcon, LibraryBigIcon, BlocksIcon, ClipboardListIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { MODULES, PRICING_ANCHOR, type Module } from '../data/content';
const ICONS: Record<Module['icon'], React.ElementType> = {
  foundations: CompassIcon,
  library: LibraryBigIcon,
  builder: BlocksIcon,
  sessions: ClipboardListIcon,
  progression: TrendingUpIcon,
  coaching: UsersIcon
};
export function Modules() {
  return <section className="bg-charcoal py-10 sm:py-12" aria-labelledby="modules-title" data-id="element-94" data-mp="189kge9mrwelh">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-8" data-id="element-95" data-mp="1d59fycyslvhs">
        <SectionHeading eyebrow="6 Core Modules" title="Everything You Need In One Professional System" subtitle="From exercise selection to professional session delivery." data-id="element-96" data-mp="1i6p268cpi81r" />

        <ul className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-3 lg:gap-4" data-id="element-97" data-mp="2tjj3x5z4hi83">
          {MODULES.map(module => {
          const Icon = ICONS[module.icon];
          return <li key={module.number} className="relative flex h-full flex-col overflow-hidden rounded-lg border border-line bg-panel p-3.5 sm:p-5" data-id="element-98" data-mp="3tzx17j3659a0">
                <span className="absolute right-2 top-1 font-display text-[34px] font-bold leading-none text-cream/[0.06] sm:text-[44px]" aria-hidden="true" data-id="element-99" data-mp="3jzmn7w9b7xts">
                  {module.number}
                </span>
                <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-100" data-mp="369awa0ogo548" />
                <p className="mt-2.5 text-[9px] font-semibold uppercase tracking-[0.22em] text-gold sm:text-[10px]" data-id="element-101" data-mp="3676sdiqkb63y">
                  Module {module.number}
                </p>
                <h3 className="mt-1 font-display text-[15px] font-bold uppercase leading-[1.1] tracking-wide text-cream sm:text-[19px]" data-id="element-102" data-mp="2walmywamrszl">
                  {module.title}
                </h3>
                <p className="mt-1.5 text-[12px] leading-snug text-mutedtext sm:text-[13.5px]" data-id="element-103" data-mp="2hnmyna72lep3">
                  {module.body}
                </p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-6 max-w-md" data-id="element-104" data-mp="28p1fbctrxvn9">
          <CtaButton href={PRICING_ANCHOR} data-id="element-105" data-mp="2cpbk4m5tyg0j">
            🚀 Get The Complete System
          </CtaButton>
        </div>
      </div>
    </section>;
}